import { Injectable } from '@angular/core';

import { FactoryBase } from '../../bases/factory/factory-base';
import { ParserFactory } from '../../services';

import { DataCollectionsShareModel } from '@osos/shared/api';
import { SharedCollectionPresenterModel } from '@osos/shared/types';
import { SharedCollectionParserV1Service } from '../../parsers/lov-parser/shared-collection-parser-v1.service';

@Injectable()
export class SharedCollectionFactoryService extends FactoryBase<
  DataCollectionsShareModel,
  SharedCollectionPresenterModel
> {
  constructor(
    parserFactory: ParserFactory,
    parser_v1: SharedCollectionParserV1Service,
  ) {
    super(parserFactory);
    // register the related parsers within the parser factory:
    parserFactory.register(parser_v1);
  }

  createDataModel(
    presenter: SharedCollectionPresenterModel,
  ): DataCollectionsShareModel {
    const parser = this.getParser(
      DataCollectionsShareModel,
      SharedCollectionPresenterModel,
    );
    const result = parser.getDataModel(presenter);
    return result;
  }

  createPresenterModel(
    model: DataCollectionsShareModel,
  ): SharedCollectionPresenterModel {
    throw new Error('Method not implemented');
  }
}
